import React from 'react'

import {
  Box,
  Display,
  Heading2,
  JustifyContent,
  Space,
  TextAlign,
} from '@gousto-internal/citrus-react'

import { LandingPageButton, StepsWithImage } from '../../../../components'
import type { HowGoustoFoodBoxesWorkTypes } from '../../../../types'
import { MealPlanningSections, TargetUri, TrackingActions } from '../../../../types/tracking'
import { HOW_GOUSTO_MENU_WORDS } from './config'

export function HowDoesGoustoMenuWork({ startOnboarding }: HowGoustoFoodBoxesWorkTypes) {
  return (
    <Box paddingH={[8, null, null, 0]} paddingV={16} maxWidth="1200px" style={{ margin: '0 auto' }}>
      <Heading2 textAlign={[TextAlign.Left, null, null, TextAlign.Center]}>
        {HOW_GOUSTO_MENU_WORDS.heading}
      </Heading2>
      <Space size={4} />
      <StepsWithImage steps={HOW_GOUSTO_MENU_WORDS.steps} />
      <Space size={6} />
      <Box display={Display.Flex} justifyContent={JustifyContent.Center}>
        <LandingPageButton
          startOnboarding={startOnboarding}
          sectionName={MealPlanningSections.HOW_DOES_GOUSTO_MENU_WORK}
          target={TargetUri.SIGNUP}
          action={TrackingActions.CLICK_GET_STARTED}
        >
          {HOW_GOUSTO_MENU_WORDS.ctaText}
        </LandingPageButton>
      </Box>
    </Box>
  )
}
